import { Cell, Grid, HFlow, Icon, Text, VFlow } from 'bold-ui'
import { Color } from 'csstype'
import React from 'react'
import { formatDate } from 'util/date/formatDate'
import { ListagemDesenvolvimentoInfantilVisitasDomiciliaresModel } from 'view/acompanhamento/acompanhamento-condicao-saude/model/lista-tematica/model-desenvolvimentoInfantil'

interface AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSectionProps {
  visitasDomiciliares: ListagemDesenvolvimentoInfantilVisitasDomiciliaresModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSection({
  visitasDomiciliares,
  iconColor,
}: Readonly<AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilVisitasDomiciliaresSectionProps>) {
  return (
    <Grid gap={1} gapVertical={0.5} alignItems='baseline'>
      <Cell size={12}>
        <HFlow hSpacing={0.5} alignItems='center'>
          <Icon width='1rem' icon='houseFilled' color={iconColor} />
          <Text fontWeight='bold'>Visitas domiciliares</Text>
        </HFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Até 24 meses (quantidade)</Text>
          <Text>{visitasDomiciliares?.qtdVisitasDomiciliares ?? 0}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Primeira visita</Text>
          <Text>{formatDate(visitasDomiciliares?.dataPrimeiraVisita)}</Text>
        </VFlow>
      </Cell>
      <Cell size={3}>
        <VFlow vSpacing={0.25}>
          <Text fontWeight='bold'>Segunda visita</Text>
          <Text>{formatDate(visitasDomiciliares?.dataSegundaVisita)}</Text>
        </VFlow>
      </Cell>
    </Grid>
  )
}
